/**
 * pmtilesProtocol.ts — register the `pmtiles://` MapLibre protocol once (T-102).
 *
 * The aggregate map tiers are single-file PMTiles pyramids read over HTTP Range requests. The
 * `pmtiles` library's Protocol handler teaches MapLibre to resolve a `pmtiles://<url>` vector
 * source by range-reading the container's header + directory. Registration is process-global and
 * idempotent — the Protocol instance owns a cache shared across every pmtiles source, so it must
 * be constructed exactly once.
 */
import maplibregl from 'maplibre-gl'
import { Protocol } from 'pmtiles'

let registered = false

export function registerPmtilesProtocol(): void {
  if (registered) return
  const protocol = new Protocol()
  maplibregl.addProtocol('pmtiles', protocol.tile)
  registered = true
}
